import React from 'react';
import IconModalWarning from 'assets/svg/icon_modal_warning.svg';

import { Button, ButtonProps, Divider, Modal, ModalDialog, ModalDialogProps, Stack, Typography } from '@mui/joy';

type IconType = 'warning';

export type CustomModalProps = {
	open: boolean;
	title: string;
	handleClose?: () => void;
	handleConfirm?: () => void;
	description?: string;
	variant?: ButtonProps['color'];
	confirmText?: string;
	loading?: boolean;
	cancelText?: string | boolean;
	maxWidth?: string;
	actionButton?: React.ReactNode;
	type?: ButtonProps['variant'];
	sx?: ModalDialogProps['sx'];
	width?: 'auto' | 'full';
	children?: React.ReactNode;
	withoutActionButton?: boolean;
	withIcon?: boolean;
	iconType?: IconType;
};

const generateIcon = (iconType: IconType) => {
	switch (iconType) {
		case 'warning':
			return IconModalWarning;
		/**Add more icon type here */
		default:
			return IconModalWarning;
	}
};

const CustomModal = ({
	open = false,
	title,
	handleClose,
	variant = 'primary',
	handleConfirm,
	maxWidth,
	width = 'full',
	description,
	sx,
	actionButton = null,
	cancelText,
	confirmText,
	loading,
	type = 'solid',
	children,
	withoutActionButton = false,
	withIcon = false,
	iconType = 'warning',
}: CustomModalProps) => {
	return (
		<Modal open={open}>
			<ModalDialog
				sx={{
					maxWidth: maxWidth ?? '368px',
					overflow: 'visible',
					width: width === 'full' ? '100%' : 'auto',
					paddingX: 3,
					paddingY: 2,
					position: 'relative',
					...sx,
				}}>
				{withIcon && (
					<Stack
						position="absolute"
						left="50%"
						top="-56px"
						zIndex={9999}
						justifyContent="center"
						alignItems="center"
						sx={{
							borderRadius: '90px',
							backgroundColor: '#F2F2F2',
							width: '112px',
							height: '112px',
							transform: 'translateX(-50%)',
						}}>
						<img src={generateIcon(iconType)} alt="icon" />
					</Stack>
				)}
				<Typography level="title-lg">{title}</Typography>
				{title && <Divider />}
				<>
					{children || (
						<Typography
							level="body-sm"
							textColor="text.secondary"
							maxWidth={maxWidth}
							width="100%"
							sx={{
								wordBreak: 'break-word',
							}}>
							{description}
						</Typography>
					)}
				</>
				{!actionButton && !withoutActionButton ? (
					<Stack direction="row" gap={1} justifyContent="flex-end" marginTop={2}>
						{typeof cancelText !== 'boolean' && (
							<Button
								color="neutral"
								variant="outlined"
								sx={{
									minWidth: 80,
									minHeight: 40,
									px: 2,
									py: 0.5,
									fontSize: '14px',
								}}
								onClick={handleClose}>
								{cancelText || 'Cancel'}
							</Button>
						)}
						<Button
							color={variant}
							variant={type}
							onClick={handleConfirm}
							loading={loading}
							sx={{
								minWidth: 80,
								minHeight: 40,
								px: 2,
								py: 0.5,
								fontSize: '14px',
							}}>
							{confirmText ? confirmText : 'Save'}
						</Button>
					</Stack>
				) : (
					<Stack direction="row" gap={1} justifyContent="flex-end" marginTop={2}>
						{actionButton}
					</Stack>
				)}
			</ModalDialog>
		</Modal>
	);
};

export default CustomModal;
